import { Button } from 'blaze-ui/Button'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { ChevronRightSmall } from 'blaze-ui/icons'
import { multiStep } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/multiStep'
import { StepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { useState } from 'react'
import { useFormikContext } from 'formik'
import Styles from './TitleSelector.module.scss'
import { TitleSelectorLoadingState } from './components/TitleSelectorLoadingState'
import { SeoKeywords } from './components/SeoKeywords'
import { ActionButtons } from './components/ActionButtons'
import { AddTitleInput } from './components/AddTitleInput'
import { TextValues } from 'components/Wizards/MobileWizards/Types'

interface Props extends StepProps {
  generateTitleOptions: (payload: TextValues) => void
  titleOptions: string[]
  setTitleOptions: (options: string[]) => void
  isGeneratingTitles: boolean
}

const TitleOptionButton = ({ title, onPress }: { title: string; onPress: () => void }) => (
  <Button variant="tertiary" onPress={onPress} className={Styles.titleOption} fullWidth useChildClass>
    <span className={Styles.titleText}>{title}</span>
    <div className={Styles.arrowContainer}>
      <ChevronRightSmall size={20} />
    </div>
  </Button>
)

export const TitleSelector = multiStep<Props>(({ schema, initialValues, submit, getSchemaField, ...props }) => {
  const { meta } = schema.describe()
  const { generateTitleOptions, titleOptions, setTitleOptions, isGeneratingTitles } = props
  const [showCustomInput, setShowCustomInput] = useState(false)
  const { values, setFieldValue } = useFormikContext<any>()

  const handleTitleSelect = (index: number) => {
    setFieldValue('title', titleOptions[index])
    submit()
  }

  const handleCustomTitleSubmit = (value: string) => {
    if (value.trim()) {
      setTitleOptions([...titleOptions, value])
    }
    setShowCustomInput(false)
  }

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <MobileWizard.Content>
        <MobileWizard.Section>
          <MobileWizard.Title>{meta.title}</MobileWizard.Title>
        </MobileWizard.Section>

        <MobileWizard.Section gap={10}>
          {isGeneratingTitles && <TitleSelectorLoadingState />}
          {!isGeneratingTitles && (
            <>
              {titleOptions.map((titleText, index) => (
                <TitleOptionButton key={index} title={titleText} onPress={() => handleTitleSelect(index)} />
              ))}
              {showCustomInput && (
                <AddTitleInput onSubmit={handleCustomTitleSubmit} onCancel={() => setShowCustomInput(false)} />
              )}
            </>
          )}
        </MobileWizard.Section>

        {!isGeneratingTitles && !showCustomInput && (
          <ActionButtons
            onWriteOwn={() => setShowCustomInput(true)}
            onRegenerate={() => generateTitleOptions(initialValues)}
          />
        )}

        {values.seo_words?.length > 0 && <SeoKeywords keywords={values.seo_words} />}
      </MobileWizard.Content>
    </form>
  )
})
